// Parse 'YYYY-MM-DD' as local midnight (not UTC) so dates don't shift a day back in US timezones
export const parseLocalDate = (dateStr) => {
  if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return new Date(dateStr + 'T00:00:00');
  }
  return new Date(dateStr);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'TBD';
  return parseLocalDate(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatDateLong = (dateStr) => {
  if (!dateStr) return 'TBD';
  return parseLocalDate(dateStr).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatTime = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const getDaysToGo = (dateStr) => {
  if (!dateStr) return '';
  const eventDate = parseLocalDate(dateStr);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffTime = eventDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return 'Past';
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Tomorrow';
  return `${diffDays} days`;
};

export const getCountdown = (eventDate) => {
  if (!eventDate) return null;
  const now = new Date();
  const event = new Date(eventDate);
  const diff = event - now;
  if (diff < 0) return null;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

export const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 18) return 'Good Afternoon';
  return 'Good Evening';
};

export const getProfileCompletion = (form) => {
  const fields = [
    { key: 'full_name', label: 'Full Name', value: form?.full_name },
    { key: 'photo_url', label: 'Profile Photo', value: form?.photo_url },
    { key: 'church_name', label: 'Church/Organization', value: form?.church_name },
    { key: 'city', label: 'City', value: form?.city },
    { key: 'state', label: 'State', value: form?.state },
    { key: 'phone', label: 'Phone Number', value: form?.phone },
    { key: 'interests', label: 'Interests', value: form?.interests?.length > 0 },
  ];
  const completed = fields.filter(f => f.value).length;
  const missing = fields.filter(f => !f.value).map(f => f.label);
  return { percentage: Math.round((completed / fields.length) * 100), missing };
};

export const toGoogleCalendar = (event) => {
  if (!event) return '';
  const startDate = new Date(event.start_date || event.start);
  const endDate = new Date(event.end_date || event.end || event.start_date || event.start);
  endDate.setHours(endDate.getHours() + 8);
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title || event.event || '')}&dates=${startDate.toISOString().replace(/-|:|\.\d\d\d/g, '')}/${endDate.toISOString().replace(/-|:|\.\d\d\d/g, '')}&details=${encodeURIComponent(event.description || '')}&location=${encodeURIComponent(event.venue_name || event.location || event.city || '')}`;
};

export const downloadICSFile = (events) => {
  if (!events || events.length === 0) return;
  const icsEvents = events.map(event => {
    const startDate = new Date(event.start_date || event.start);
    const endDate = new Date(event.end_date || event.end || event.start_date || event.start);
    endDate.setHours(endDate.getHours() + 8);
    const fmt = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const location = [event.venue_name, event.city, event.location].filter(Boolean).join(', ');
    return [
      'BEGIN:VEVENT',
      `UID:${event.id}@confplanners.com`,
      `DTSTAMP:${fmt(new Date())}`,
      `DTSTART:${fmt(startDate)}`,
      `DTEND:${fmt(endDate)}`,
      `SUMMARY:${(event.title || event.event || 'Event').replace(/[\n,]/g, ' ')}`,
      `LOCATION:${location.replace(/[\n,]/g, ' ')}`,
      `DESCRIPTION:${(event.description || '').replace(/[\n,]/g, ' ')}`,
      'END:VEVENT'
    ].join('\r\n');
  }).join('\r\n');

  const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//ConfPlanner//EN', icsEvents, 'END:VCALENDAR'].join('\r\n');
  const blob = new Blob([ics], { type: 'text/calendar' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'my-events.ics';
  a.click();
  URL.revokeObjectURL(url);
};
